function AntiguaAndBarbuda({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_522)">
  <path d="M0 16.0001C0 17.096 0.1105 18.1662 0.320437 19.2001L16 20.174L31.6796 19.2001C31.8896 18.1662 32 17.096 32 16.0001C32 14.9042 31.8895 13.834 31.6796 12.8001L16 11.8262L0.320437 12.8001C0.1105 13.834 0 14.9042 0 16.0001H0Z" fill="#0052B4"/>
  <path d="M31.6796 19.2002H0.320435C1.80287 26.5033 8.25943 32.0002 16 32.0002C23.7405 32.0002 30.1971 26.5033 31.6796 19.2002Z" fill="#F0F0F0"/>
  <path d="M0.320435 12.8H31.6797C30.1971 5.49688 23.7407 0 16 0C8.25931 0 1.80287 5.49688 0.320435 12.8Z" fill="black"/>
  <path d="M22.9565 12.8003H9.04346L11.886 11.4632L10.3723 8.71037L13.4588 9.30068L13.8501 6.18262L16 8.47599L18.15 6.18262L18.541 9.30068L21.6276 8.71037L20.1141 11.4633L22.9565 12.8003Z" fill="#FFDA44"/>
  <path d="M0 16C0 24.8365 7.1635 32 16 32L3.19975 6.39941C1.19075 9.07373 0 12.3977 0 16Z" fill="#A2001D"/>
  <path d="M16 32C24.8365 32 32 24.8365 32 16C32 12.3977 30.8092 9.07373 28.8002 6.39941L16 32Z" fill="#A2001D"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default AntiguaAndBarbuda;
